module.exports = __webpack_public_path__ + "img/아처.698d138d.png";